/*
 *
 * PageState constants
 *
 */
export const scope = "app/PageState/";

/**
 * treatmentFromTimeSlot
 */
export const SET_TREATMENT_TIME_SLOT = `${scope}SET_TREATMENT_TIME_SLOT`;
